module.exports = __webpack_public_path__ + "static/media/change_04.dce9c0ac.jpg";